import './map-view.scss';
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, Marker, Popup,useMap} from "react-leaflet";
import { useContext, useEffect, useMemo, useState } from 'react';
import type { MapLocation } from '../../../interfaces/MapLocation';
import { LocationsContext } from '../../map-artworks/map-artworks';
import { useRef } from 'react';
import { LANGUAGES } from '../../../utils/constants/languages';
import { LanguageContext } from '../../../providers/LanguageProvider';
import L from 'leaflet';
import markerIcon from '../../../assets/icon-marker.svg';

const customIcon = new L.Icon({
    iconUrl:markerIcon, // Chemin vers le fichier SVG ou PNG
    iconSize: [48, 64], // Taille de l'icône
    iconAnchor: [24, 64], // Point d'ancre pour le centre de l'icône (par défaut)
    popupAnchor: [0, -48], // Positionnement des infobulles par rapport à l'icône
    shadowSize: [70, 50],
    shadowAnchor: [35, 45]
});

export function MapFlyTo({markerRefs}:any){

    const map = useMap();
    const locationObject = useContext<any>(LocationsContext);
    
    useEffect(()=>{
        if(!locationObject.selectedLocation?.coordinates) return;
        map.flyTo([locationObject.selectedLocation.coordinates.coordinates[1],locationObject.selectedLocation.coordinates.coordinates[0]], map.getZoom())
        map.once("moveend", () => {
		    if (markerRefs) {
                markerRefs.current[locationObject.selectedLocation.id].openPopup();
            }   
          });
		
    },[locationObject.selectedLocation?.coordinates])
    return null;
}



export function MapView(){

    const lang = useContext(LanguageContext);
    const localLanguage =LANGUAGES.find((language) => language.code === lang.language)?.locale ?? lang.language;
    const [locationDatas,setLocationDatas]= useState<any>(null);
    const markerRefs = useRef<Record<number, L.Marker | null>>({});
    const locationObject = useContext<any>(LocationsContext);

    function handleClick(location:MapLocation){

        if (localLanguage == 'fr-FR'){
            setLocationDatas(location);
        }else{
            const newSelectedLocation = location.translations?.find((elt:any)=>elt.languages_code== localLanguage);
            setLocationDatas({
                ...location,
                name:newSelectedLocation?.name
            });
        } 
        locationObject.setSelectedLocation(location);
    }


    useMemo(()=>{
       
        if(!locationObject.selectedLocation){
            return;
        }else{
            if (localLanguage == 'fr-FR'){
                setLocationDatas(locationObject.selectedLocation)
            }else{
                const newSelectedLocation = locationObject?.selectedLocation?.translations?.find((elt:any)=>elt.languages_code== localLanguage);
                setLocationDatas({
                    ...location,
                    name:newSelectedLocation?.name
                });
            } 
        }
    },[lang,locationObject.selectedLocation])

    return(
        <>
            <MapContainer className='mymap' center={[48.4585698, 2.1569416]} zoom={13} scrollWheelZoom={false}>
                <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                />
                {locationObject.locations.map((location:MapLocation)=>{
                    if (!location.coordinates) return null;
                    return <Marker ref={(ref)=>{
                        markerRefs.current[location.id] = ref;
                    }} 
                    key={location.id} 
                    eventHandlers={{click:()=>handleClick(location)}} 
                    icon={customIcon}
                    position={[location.coordinates.coordinates[1],location.coordinates.coordinates[0]]} >
                        <Popup>
                            <figure>
                                <img src={`/api/assets/${location.map_cover_image}?key=location-thumbnail`} title={locationDatas?.name}  alt={locationDatas?.name} />
                            </figure>
                            <h3>{locationDatas?.name}</h3>
                        </Popup>
                    </Marker>
                })}
                <MapFlyTo markerRefs={markerRefs}/>
            </MapContainer>
        </>
    )

}



